import { render, staticRenderFns } from "./LedgerMapping.vue?vue&type=template&id=3891de24"
import script from "./LedgerMapping.vue?vue&type=script&lang=js"
export * from "./LedgerMapping.vue?vue&type=script&lang=js"
import style0 from "./LedgerMapping.vue?vue&type=style&index=0&id=3891de24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports